<template>
  <div v-if="isVisible" class="cookies-popup">
    <div class="cookies-popup__content">
      <template v-if="adjustView">
        <div class="cookies-popup__message">
          <div class="cookies-popup__consent">
            <div>
              <label for="consent__security">
                <div
                  class="custom-checkbox"
                  :class="[
                    {
                      'custom-checkbox--disabled': consent.security,
                    },
                  ]">
                  <div class="custom-checkbox__inner"></div>
                  <input
                    id="consent__security"
                    v-model="consent.security"
                    disabled
                    type="checkbox" />
                </div>
              </label>
            </div>
            <p v-html="$t('COOKIE_POLICY.BUTTONS.CONSENT.SECURITY')"></p>
          </div>
          <div class="cookies-popup__consent">
            <div>
              <label for="consent__analitic">
                <div
                  class="custom-checkbox"
                  :class="[
                    {
                      'custom-checkbox--primary': consent.analitic,
                    },
                  ]">
                  <div class="custom-checkbox__inner"></div>
                  <input
                    id="consent__analitic"
                    v-model="consent.analitic"
                    type="checkbox" />
                </div>
              </label>
            </div>
            <p v-html="$t('COOKIE_POLICY.BUTTONS.CONSENT.ANALITIC')"></p>
          </div>
          <div class="cookies-popup__consent">
            <div>
              <label for="consent__functional">
                <div
                  class="custom-checkbox"
                  :class="[
                    {
                      'custom-checkbox--primary': consent.functional,
                    },
                  ]">
                  <div class="custom-checkbox__inner"></div>
                  <input
                    id="consent__functional"
                    v-model="consent.functional"
                    type="checkbox" />
                </div>
              </label>
            </div>
            <p v-html="$t('COOKIE_POLICY.BUTTONS.CONSENT.FUNCTIONAL')"></p>
          </div>
          <div class="cookies-popup__consent">
            <div>
              <label for="consent__ad">
                <div
                  class="custom-checkbox"
                  :class="[
                    {
                      'custom-checkbox--primary': consent.ad,
                    },
                  ]">
                  <div class="custom-checkbox__inner"></div>
                  <input
                    id="consent__ad"
                    v-model="consent.ad"
                    type="checkbox" />
                </div>
              </label>
            </div>
            <p v-html="$t('COOKIE_POLICY.BUTTONS.CONSENT.AD')"></p>
          </div>
        </div>
        <div class="cookies-popup__actions flex !justify-center">
          <button class="btn btn-primary" @click="acceptPolicy()">
            {{ $t('COOKIE_POLICY.BUTTONS.ACCEPT') }}
          </button>
        </div>
      </template>
      <template v-else>
        <div class="cookies-popup__title">
          {{ $t('COOKIE_POLICY.TITLE') }}
        </div>
        <div
          class="cookies-popup__message"
          v-html="$t('COOKIE_POLICY.MESSAGE')"></div>
        <div class="cookies-popup__actions">
          <button class="btn btn-primary" @click="acceptPolicy(true)">
            {{ $t('COOKIE_POLICY.BUTTONS.ACCEPT_ALL') }}
          </button>
          <button class="btn" @click="closePopup()">
            {{ $t('COOKIE_POLICY.BUTTONS.REJECT') }}
          </button>
          <button class="btn" @click="adjustPolicy()">
            {{ $t('COOKIE_POLICY.BUTTONS.ADJUST') }}
          </button>
        </div>
      </template>
    </div>
  </div>
</template>
<script setup lang="ts">
const isVisible = ref(false)
const adjustView = ref(false)

function closePopup() {
  isVisible.value = false
}

const consent = reactive({
  security: true,
  analitic: false,
  functional: false,
  ad: false,
})
function acceptPolicy(all = false) {
  if (all) {
    Object.keys(consent).forEach(stateName => (consent[stateName] = true))
  }

  const value = Object.entries(consent)
    .map(([key, value]) => `${key}=${value}`)
    .join('&')

  const cookieExpire = new Date()
  cookieExpire.setFullYear(cookieExpire.getFullYear() + 1)
  document.cookie = `EaslyPolicyAccepted=${escape(value)}; expires=${cookieExpire.toUTCString()}; path=/`
  closePopup()
}

function adjustPolicy() {
  adjustView.value = true
}
onMounted(() => {
  if (document.cookie.indexOf('EaslyPolicyAccepted') == -1) {
    isVisible.value = true
  }
})
</script>
<style lang="scss" scoped>
.cookies-popup {
  position: fixed;
  width: 100vw;
  height: 100vh;
  inset: 0;
  z-index: 99999;
  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }
  &__content {
    background: #ffffff;
    border-radius: 10px;
    padding: 80px 60px 30px;
    height: fit-content;
    width: min(90vw, 800px);
    position: absolute;
    inset: 0;
    margin: auto;
    display: grid;
    gap: 20px;
    max-height: 500px;
  }

  &__consent {
    display: flex;
    gap: 15px;
    align-items: baseline;
    &:not(:last-child) {
      margin-bottom: 20px;
    }

    .custom-checkbox {
      border-color: #3870ff !important;
      border-width: 2px;

      &--disabled {
        --outer-bg-color: #8080806e !important;
        --inner-bg-color: #8080806e !important;
      }
    }
  }

  &__title {
    font-weight: bold;
    font-size: 26px;
  }

  &__message {
    line-height: 1.75;
    max-height: 70vh;
    overflow-y: auto;
    b {
      color: #000 !important;
    }
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    flex-wrap: wrap;

    .btn {
      border: 2px solid #3870ff;
      --bg-color: transparent;
      --text-color: #3870ff;
      padding: 10px 30px;
      border-radius: 20px;
      &-primary {
        --bg-color: #3870ff;
        --text-color: #fff;
      }
    }
  }
}
@media (max-width: 1496px) {
  .cookies-popup {
    &__title {
      font-size: var(--font-size);
    }
    &__message {
      font-size: var(--font-small);
    }
  }
}
@media (max-width: 768px) {
  .cookies-popup {
    &__content {
      padding: 25px;
      max-height: 600px;
    }
    &__message {
      font-size: var(--font-xsmall);
    }
    &__actions {
      flex-direction: column;
      .btn {
        font-size: var(--font-exsmall) !important;
      }
    }
  }
}
</style>
